var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28088 3.08635C1.05242 2.93122 0.74147 2.99067 0.586347 3.21912C0.431224 3.44758 0.49067 3.75853 0.719124 3.91365L1.28088 3.08635ZM4.68182 6L4.40094 6.41365C4.59466 6.54519 4.85371 6.52467 5.02431 6.36428L4.68182 6ZM10.3425 1.36428C10.5437 1.17513 10.5534 0.8587 10.3643 0.657512C10.1751 0.456324 9.8587 0.446566 9.65751 0.635717L10.3425 1.36428ZM0.719124 3.91365L4.40094 6.41365L4.96269 5.58635L1.28088 3.08635L0.719124 3.91365ZM5.02431 6.36428L10.3425 1.36428L9.65751 0.635717L4.33933 5.63572L5.02431 6.36428Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9e552e06db7f181177750dc76dc98abf.svg";
export { ForwardRef as ReactComponent };